import {useCallback} from 'react';
import {useSearchParams} from 'react-router-dom';
import {redirectWithForwardUrl} from 'utils/utils';

import {useGetForwardUrl} from './useGetFowardUrl';
import {AdobeEvent, useTrackEvent} from './useTrackEvent';

export const useDismissBehavior = (trackingEventName?: string) => {
  const [searchParams] = useSearchParams();
  const forwardUrl = useGetForwardUrl();

  const {trackAdobeEvent} = useTrackEvent();

  return useCallback(() => {
    if (trackingEventName) {
      trackAdobeEvent({
        event: AdobeEvent.click,
        click: {
          name: trackingEventName,
        },
      });
    }

    redirectWithForwardUrl(forwardUrl);
  }, [forwardUrl, trackAdobeEvent, trackingEventName]);
};
